import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	mainActions: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
	},
	deleteButton: {
		marginTop: theme.spacing(1),
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
}));
